

import React from 'react';
import ServiceForm from '../components/ServiceForm';
import { renderEndpoint } from '../utils';


const serviceEndpoint = "season/%sid/training-session/%tid/notes/%nid/delete";

const serviceArguments = []

const serviceUrlArguments = [
  { name: 'sid', type: 'numeric',  mandatory: true, default: '', description: 'Season ID'},
  { name: 'tid', type: 'numeric',  mandatory: true, default: '', description: 'Training Session ID'},
  { name: 'nid', type: 'numeric',  mandatory: true, default: '', description: 'Note ID'}
]

const serviceSample = {};


export function TrainingSessionNoteDelete() {
  return <TrainingSessionNoteDeleteComponent/>;
}


class TrainingSessionNoteDeleteComponent extends React.Component {

  render() {

        return (
            <div>
                  <h3>Training Sessione Delete Note</h3>

                  <p>Endpoint: <b>{renderEndpoint(serviceEndpoint)}</b></p>

                  <p>
                    This service can be used to delete a note for a specific training session.<br/>
                    Only our owns note can be deleted.<br/>
                  </p>
                  <ServiceForm
                        args={serviceArguments}
                        urlArgs={serviceUrlArguments}
                        sample={serviceSample}
                        endpoint={serviceEndpoint}
                        authRequired={true}
                        usePayload={false}
                        returnImage={false}
                  />

                  <h4>Request</h4>
                  <p>
                    GET request
                  </p>
                  <h4>Response</h4>
                  <p>
                  The service returns ({"{"} result: "ok" {"}"} or an error.
                  </p>

            </div>
        );
  }


} 